import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { TranslationService } from './modules/i18n';
// language list
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { locale as trLang } from './modules/i18n/vocabs/tr';
import { locale as menuEnglish } from '../app/_metronic/layout/components/sidebar/sidebar-menu/i18n/en';
import { locale as menuTurkish } from '../app/_metronic/layout/components/sidebar/sidebar-menu/i18n/tr';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { ThemeService } from './core/theming/theme.service';
import { SidebarMenuService } from './_metronic/layout/components/sidebar/sidebar-menu/sidebar-menu.service';
import { Subject } from 'rxjs';
import { menu } from './_metronic/layout/components/sidebar/sidebar-menu/sidebar-menu';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './modules/auth/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

@Component({
    // tslint:disable-next-line:component-selector
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AppComponent implements OnInit {
  menu: any;
  // Private
  private _unsubscribeAll: Subject<any>;

  public user: any;
  public roles: [];

  /** /calculation altindaki sayfalarda buton temasi (Turkcell'de sari "Ekle") icin scope class. */
  @HostBinding('class.cg-calc-scope') isCalculationScope = false;

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private themeService: ThemeService,
    private menuService: SidebarMenuService,
    private _router: Router,
    private authService: AuthService,
    private modalService: NgbModal
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang,
      trLang,
      menuEnglish,
      menuTurkish
    );

    // Get the application main menu
    this.menu = menu;

    // Register the menu to the menu service
    this.menuService.register('main', this.menu);

    // Set the main menu as our current menu
    this.menuService.setCurrentMenu('main');

    // this.user = localStorage.getItem("currentUser");
    // this.user = JSON.parse(this.user);
    // if (this.user != null && this.user != undefined)
    //   this.roles = this.user.roles;

    // if (this.roles != null && this.roles != undefined)
    // {
    //   if (this.roles.length <= 1) {
    //     this.roles.forEach(item => {
    //       if(item == "MyJtrRevealUser")
    //       {
    //         this._router.navigate(["/equipment"])
    //       }
    //     });
    //   }
    // }
  }

  ngOnInit() {
    this.modeService.init();
    this.themeService.init();

    // Check if user is logged in and refresh user data
    this.refreshUserDataOnAppStart();

    this.setupGlobalBackButtonHandler();
    this.watchCalculationScope();
  }

  /**
   * /calculation altindaki tum sayfalar (ana liste + calculation-detail'in
   * tek tek routelanan alt sayfalari) ortak bir DOM sarmalayicisi paylasmiyor,
   * o yuzden route bazli bir body class burada tutuluyor. Turkcell temasinda
   * sadece bu kapsamdaki .btn-success ("Ekle") butonlarini sariya cevirmek icin.
   */
  private watchCalculationScope(): void {
    this.isCalculationScope = this._router.url.startsWith('/calculation');
    this._router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.isCalculationScope = event.urlAfterRedirects.startsWith('/calculation');
      });
  }
  setupGlobalBackButtonHandler() {
    window.addEventListener('popstate', (event) => {
      if (this.modalService.hasOpenModals()) {
        event.preventDefault();
        this.modalService.dismissAll();
        history.pushState(null, '', window.location.href);
        return;
      }

      if (Swal.isVisible()) {
        event.preventDefault();
        Swal.close();
        history.pushState(null, '', window.location.href);
        return;
      }
    });
  }

  private refreshUserDataOnAppStart() {
    // Check if user exists in localStorage
    const currentUserString = localStorage.getItem('currentUser');
    if (currentUserString) {
      try {
        const currentUser = JSON.parse(currentUserString);
        // If user has a token, refresh the user data
        if (currentUser && currentUser.token) {
          // Şirket/uygulama seçim ekranları zaten UserRefreshData tetikliyor; doğrudan bu URL ile gelindiğinde çift isteği önle
          if (
            this._router.url.includes('/applicationadmin/company-select') ||
            this._router.url.includes('/applicationadmin/application-select')
          ) {
            return;
          }
          // console.log('Refreshing user data on app start...');
          this.authService.refreshUserData().subscribe({
            next: (refreshedData) => {
              if (refreshedData) {
                // console.log('User data refreshed successfully on app start');
              }
            },
            error: (error) => {
              console.error('Failed to refresh user data on app start:', error);
            },
          });
        }
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
      }
    }
  }
}
